import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Pos, PosDetailWithOrders } from '../../../../../core/models/pos.model';
import { Order } from '../../../../../core/models/order.model';

export type ModalMode = 'create' | 'edit' | 'transfer';

@Component({
  selector: 'app-order-selector',
  templateUrl: './order-selector.component.html',
  styleUrls: ['./order-selector.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderSelectorComponent implements OnInit {
  @Input() pos: Pos;
  public orders: Order[] = [];

  orderSelectorForm: FormGroup;

  /**
   * Constructor
   */
  constructor(
    public matDialogRef: MatDialogRef<OrderSelectorComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      pos: PosDetailWithOrders;
      mode: ModalMode;
      quantity: number;
      itemName: string;
    },
    private _formBuilder: FormBuilder
  ) {}

  /**
   * On init
   */
  ngOnInit(): void {
    this.pos = this.data.pos.pos;
    this.orders = this.data.pos.orders;

    // Create the form
    this.orderSelectorForm = this._formBuilder.group({
      quantity: [this.data.quantity ?? 1, [Validators.required, Validators.min(1)]]
    });

    if (this.data.mode === 'create') {
      this.orderSelectorForm.addControl('order', new FormControl('', Validators.required));
    }
  }

  /**
   * Save and close
   */
  saveAndClose(): void {
    // Save the message as a draft
    this.saveAsDraft();

    // Close the dialog
    this.matDialogRef.close();
  }

  /**
   * Discard the message
   */
  discard(): void {}

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  send(): void {
    // Check if the form is valid before proceeding
    if (this.orderSelectorForm.invalid) {
      // Mark all fields as touched to display validation errors
      this.orderSelectorForm.markAllAsTouched();
      return;
    }

    // Retrieve the selected order and quantity from the form
    const selectedOrderId = this.orderSelectorForm.get('order')?.value ?? this.orders[0].id;
    const selectedQuantity = this.orderSelectorForm.get('quantity')?.value;

    // Create the result payload (e.g., use it for backend submission or event emission)
    const payload = {
      orderId: selectedOrderId,
      quantity: selectedQuantity
    };

    // Close the dialog with the payload
    this.matDialogRef.close(payload);
  }
}
